<template>
    <rkm-form
        ref="Form"
        show-legend
    >
        <CidadaoEndereco
            :termos-invalidos="form.cidadao.termosInvalidos"
            :data-atual="form.cidadao.dataAtual"
            :form="form.cidadao.endereco"
            :isPermissaoEndereco="form.isPermissaoEndereco"
            :model="model.cidadao"
        />
    </rkm-form>
</template>

<script>
// Components.
import CidadaoEndereco from '@/components/cadastro/cidadao/Endereco'

export default {
    components: { CidadaoEndereco },
    props: {
        form: { type: Object, required: true },
        model: { type: Object, required: true },
    },
    methods: {
        validate() {

            return this.$refs.Form.validate()
        },
    }
}
</script>